import { useState } from 'react';
import { Bell, User, Settings, LogOut } from 'lucide-react';
import api from '../../request'; // Adjust the import based on your API setup
import { Navigate } from 'react-router-dom';

export default function Header() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
const handleLogout = async () => {
  try {
    await api.post('/logout');
    localStorage.removeItem('stepping4life_user'); // Remove local user data
    window.location.href = '/login'; // Redirect to login
  } catch (error) {
    console.error('Logout failed:', error);
  }
};

  const handleSettings = () => {
    // Add your settings navigation logic here
     
    setIsDropdownOpen(false);
    window.location.href = '/settings';
  };

  return (
    <header className="bg-white lg:ml-64 shadow-sm py-4 px-6 sticky top-0 z-10">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <span className="text-primary font-bold text-xl">Stepping4Life</span>
        </div>
        <div className="flex items-center space-x-4">
          <button className="text-text-secondary p-2 rounded-full hover:bg-background-light relative">
            <Bell size={20} />
            <span className="absolute top-1 right-1 bg-accent w-2 h-2 rounded-full"></span>
          </button>
          
          {/* User Dropdown */}
          <div className="relative">
            <button
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="flex items-center hover:bg-gray-100 rounded-lg p-1 transition-colors"
            >
              <div className="h-8 w-8 rounded-full bg-primary text-white flex items-center justify-center">
                <User size={16} />
              </div>
            </button>

            {/* Dropdown Menu */}
            {isDropdownOpen && (
              <>
                {/* Backdrop to close dropdown when clicking outside */}
                <div 
                  className="fixed inset-0 z-10" 
                  onClick={() => setIsDropdownOpen(false)}
                />
                
                {/* Dropdown Content */}
                <div className="absolute right-0 top-full mt-1 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-20">
                  <div className="py-1">
                    <button
                      onClick={handleSettings}
                      className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                    >
                      <Settings size={16} className="mr-3" />
                      Settings
                    </button>
                    
                    <hr className="border-gray-200" />
                    
                    <button
                      onClick={handleLogout}
                      className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                    >
                      <LogOut size={16} className="mr-3" />
                      Logout
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}